module.exports = __webpack_public_path__ + "img/12_28.ebbd6111.png";